import { render, staticRenderFns } from "./RejectButton.vue?vue&type=template&id=67daef74&"
import script from "./RejectButton.vue?vue&type=script&lang=js&"
export * from "./RejectButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports